(function () {
  const menu = document.getElementById('daeker-slide-menu');
  const trigger = document.querySelector('.header__icon--menu-trigger');
  if (!menu || !trigger) return;

  const panel = menu.querySelector('.daeker-slide-menu__panel');
  const overlay = menu.querySelector('.daeker-slide-menu__overlay');
  const links = menu.querySelectorAll('.daeker-slide-menu__link');
  const triggerLabel = trigger.querySelector('span');
  const CLOSE_DURATION_MS = 720;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let closeTimer = null;
  let touchStartY = null;

  function setClosedState() {
    menu.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-label', 'Open menu');
    if (triggerLabel) triggerLabel.textContent = 'MENU';
    document.body.classList.remove('daeker-menu-open');
  }

  function finishClose() {
    menu.classList.remove('is-closing');
    window.clearTimeout(closeTimer);
    closeTimer = null;
    unbindScrollClose();
  }

  function openMenu() {
    window.clearTimeout(closeTimer);
    menu.classList.remove('is-closing');
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-label', 'Close menu');
    if (triggerLabel) triggerLabel.textContent = 'CLOSE MENU';
    document.body.classList.add('daeker-menu-open');
    bindScrollClose();
    window.setTimeout(function () {
      if (links.length) links[0].focus();
    }, 80);
  }

  function closeMenu(options) {
    const animated = options && options.animated;

    if (menu.classList.contains('is-closing')) return;
    if (!menu.classList.contains('is-open')) return;

    setClosedState();

    if (animated && !prefersReducedMotion) {
      menu.classList.add('is-closing');
      menu.classList.remove('is-open');
      closeTimer = window.setTimeout(finishClose, CLOSE_DURATION_MS);
      return;
    }

    menu.classList.remove('is-open', 'is-closing');
    finishClose();
  }

  function onScrollCloseAttempt(event) {
    if (!menu.classList.contains('is-open') || menu.classList.contains('is-closing')) return;

    if (event.type === 'wheel') {
      if (event.deltaY === 0 && event.deltaX === 0) return;
      event.preventDefault();
    }

    if (event.type === 'touchmove' && touchStartY === null) return;

    if (event.type === 'touchmove') {
      const deltaY = Math.abs(event.touches[0].clientY - touchStartY);
      if (deltaY < 8) return;
      event.preventDefault();
    }

    closeMenu({ animated: true });
  }

  function onTouchStart(event) {
    if (!menu.classList.contains('is-open')) return;
    touchStartY = event.touches[0].clientY;
  }

  function bindScrollClose() {
    window.addEventListener('wheel', onScrollCloseAttempt, { passive: false });
    window.addEventListener('scroll', onScrollCloseAttempt, { passive: true });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onScrollCloseAttempt, { passive: false });
  }

  function unbindScrollClose() {
    window.removeEventListener('wheel', onScrollCloseAttempt);
    window.removeEventListener('scroll', onScrollCloseAttempt);
    window.removeEventListener('touchstart', onTouchStart);
    window.removeEventListener('touchmove', onScrollCloseAttempt);
    touchStartY = null;
  }

  function toggleMenu() {
    if (menu.classList.contains('is-open')) {
      closeMenu({ animated: true });
    } else {
      openMenu();
    }
  }

  trigger.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    toggleMenu();
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      closeMenu({ animated: true });
    });
  }

  document.addEventListener('click', function (event) {
    if (!menu.classList.contains('is-open')) return;
    if (panel.contains(event.target) || trigger.contains(event.target)) return;
    closeMenu({ animated: true });
  });

  links.forEach(function (link) {
    link.addEventListener('click', function () {
      closeMenu();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) {
      closeMenu({ animated: true });
      trigger.focus();
    }
  });

  panel.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || !menu.classList.contains('is-open')) return;

    const focusable = panel.querySelectorAll('a[href], button:not([disabled])');
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
